import * as React from 'react';

export function PreventImplicitSubmission(): JSX.Element {
  /* create a dummy input element to prevent implicit submission */
  /* see. https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#implicit-submission */
  return <input type="text" style={{display: 'none'}} />;
}
